import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { MushroomsProvider } from "./context/MushroomsContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import MushroomDetailPage from "./pages/MushroomDetailPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminMushroomsPage from "./pages/admin/AdminMushroomsPage";
import AdminMushroomForm from "./pages/admin/AdminMushroomForm";
import AdminPodcastsPage from "./pages/admin/AdminPodcastsPage";
import AdminPreOrdersPage from "./pages/admin/AdminPreOrdersPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
      <LanguageProvider>
      <AuthProvider>
        <CustomerAuthProvider>
          <MushroomsProvider>
            <CartProvider>
              <Routes>
                {/* Customer Routes */}
                <Route path="/" element={<><Navbar /><CartDrawer /><HomePage /></>} />
                <Route path="/shop" element={<><Navbar /><CartDrawer /><ShopPage /></>} />
                <Route path="/mushroom/:id" element={<><Navbar /><CartDrawer /><MushroomDetailPage /></>} />
                <Route path="/my-orders" element={<><Navbar /><CartDrawer /><MyOrdersPage /></>} />

                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
                <Route path="/admin" element={
                  <ProtectedAdminRoute>
                    <AdminLayout />
                  </ProtectedAdminRoute>
                }>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="mushrooms" element={<AdminMushroomsPage />} />
                  <Route path="mushrooms/new" element={<AdminMushroomForm />} />
                  <Route path="mushrooms/:id/edit" element={<AdminMushroomForm />} />
                  <Route path="podcasts" element={<AdminPodcastsPage />} />
                  <Route path="preorders" element={<AdminPreOrdersPage />} />
                  <Route path="orders" element={<AdminOrdersPage />} />
                </Route>

                <Route path="*" element={<><Navbar /><CartDrawer /><HomePage /></>} />
              </Routes>
            </CartProvider>
          </MushroomsProvider>
        </CustomerAuthProvider>
      </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
